import * as React from "react";

import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";
import type { ISO639_1_Language } from "@shared/types";
import { trackEvent } from "../../services/metrics";

const languages: Record<ISO639_1_Language, string> = {
	ar: "arabic",
	am: "amharic",
	bg: "bulgarian",
	bn: "bengali",
	ca: "catalan",
	cs: "czech",
	da: "danish",
	de: "german",
	el: "greek",
	en: "english",
	es: "spanish",
	es_419: "spanish (la)", //es in supported languages
	et: "estonian",
	fa: "persian",
	fi: "finnish",
	fil: "filipino", //tl in supported languages
	fr: "french",
	gu: "gujarati",
	he: "hebrew", //iw in supported languages
	hi: "hindi",
	hr: "croatian",
	hu: "hungarian",
	id: "indonesian",
	it: "italian",
	ja: "japanese",
	kn: "kannada",
	ko: "korean",
	lt: "lithuanian",
	lv: "latvian",
	ml: "malayalam",
	mr: "marathi",
	ms: "malay",
	nl: "dutch",
	no: "norwegian",
	pl: "polish",
	pt_br: "portuguese (brazil)", //pt in supported languages
	pt_pt: "portuguese (portugal)", //pt in supported languages
	ro: "romanian",
	ru: "russian",
	sk: "slovak",
	sl: "slovenian",
	sr: "serbian",
	sv: "swedish",
	sw: "swahili",
	ta: "tamil",
	te: "telugu",
	th: "thai",
	tr: "turkish",
	uk: "ukrainian",
	vi: "vietnamese",
	zh_cn: "chinese (simplified)", //zh-cn
	zh_tw: "chinese (traditional)", //zh-tw
};

interface SelectProps {
	value: ISO639_1_Language;
	defaultValue?: string;
	disabled?: boolean;
	onChange(value: ISO639_1_Language): void;
}

export const LanguageSelect: React.FC<SelectProps> = (props) => {
	const { value, defaultValue = "en", onChange, disabled = false } = props;

	const handleChange = (value: string) => {
		onChange(value as ISO639_1_Language);

		trackEvent({
			event: "language_selected",
			metadata: { language: value },
		});
	};

	return (
		<Select
			value={value}
			onValueChange={handleChange}
			defaultValue={defaultValue}
			disabled={disabled}
		>
			<SelectTrigger className="">
				<SelectValue placeholder="Select a language" />
			</SelectTrigger>
			<SelectContent>
				{Object.entries(languages).map(([value, label]) => (
					<SelectItem key={value} value={value}>
						{label.charAt(0).toUpperCase() + label.slice(1)}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};
